export function CopyIcon(props: React.SVGAttributes<{}>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.59961 11.3973C6.59961 8.67126 6.59961 7.30826 7.44261 6.46126C8.28661 5.61426 9.64361 5.61426 12.3596 5.61426H15.2396C17.9546 5.61426 19.3126 5.61426 20.1556 6.46126C20.9996 7.30826 20.9996 8.67126 20.9996 11.3973V16.2173C20.9996 18.9433 20.9996 20.3063 20.1556 21.1533C19.3126 22.0003 17.9546 22.0003 15.2396 22.0003H12.3596C9.64361 22.0003 8.28661 22.0003 7.44261 21.1533C6.59861 20.3063 6.59961 18.9433 6.59961 16.2173V11.3973Z"
        fill="currentColor"
      />
      <path
        opacity="0.5"
        d="M4.172 3.172C3 4.343 3 6.229 3 10V12C3 15.771 3 17.657 4.172 18.828C4.789 19.446 5.605 19.738 6.792 19.876C6.6 19.036 6.6 17.88 6.6 16.216V11.397C6.6 8.671 6.6 7.308 7.443 6.461C8.287 5.614 9.644 5.614 12.36 5.614H15.24C16.892 5.614 18.04 5.614 18.878 5.804C18.74 4.611 18.448 3.792 17.828 3.172C16.657 2 14.771 2 11 2C7.229 2 5.343 2 4.172 3.172Z"
        fill="currentColor"
      />
    </svg>
  );
}
